module.controller('bankTransferRecurringCtrl', ['Session', '$scope', '$rootScope', '$state', '$stateParams', '$http', 'cacheService', 'baseURI', 'recurringTransferService', 'Transform', 'OVERLAY', 'DAY_OF_WEEK', 'DAY_OF_MONTH', 'FREQUENCY_OPTIONS',
  function (Session, $scope, $rootScope, $state, $stateParams, $http, cacheService, baseURI, recurringTransferService, Transform, OVERLAY, DAY_OF_WEEK, DAY_OF_MONTH, FREQUENCY_OPTIONS){
    var transferType = $stateParams.transferType;
    var recurringId  = $stateParams.recurringId || null;
    var createUrl    = baseURI + 'bank/transfer/auto';
    var editUrl;
    var transfer;

    $scope.alert = {};
    $scope.alert.alertMessage = 'Sorry, we were unable to process the bank transfer at this time.  If you continue to experience this issue, please call customer service ' + $scope.brand.programContactPhone + '.';

    $scope.scheduleText         = 'Select Schedule';

    $scope.sourceLabel          = (transferType == 'load' ? 'Select Source' : 'Select Destination');
    $scope.isExpense            = Session.getExpense();
    $scope.transferType         = transferType;
    $scope.overlay              = (transferType == 'load' ? OVERLAY['member.home.bank/load/recurring'] : OVERLAY['member.home.bank/withdraw/recurring']);
    $scope.showScheduleOption   = false;
    $scope.attempted            = false;

    $scope.formData             = {};

    // Datepicker
    $scope.datePicker           = {};
    $scope.datePicker.day1      = {};
    $scope.datePicker.day2      = {};
    $scope.datePicker.dateSelect= {};
    $scope.dayOptions           = [];
    $scope.dateOptions          = [];
    $scope.frequencyOptions     = FREQUENCY_OPTIONS;
    $scope.scheduleText         = 'Select Schedule';

    if(transferType === 'withdraw'){
      $scope.scheduleMessage  = 'How often would you like to transfers funds to your bank? Customize the schedule below.';
    } else if(transferType === 'load') {
      $scope.scheduleMessage  = 'How often would you like to load money onto your card? Would you like to schedule it around your paycheck? Customize the loading schedule below.';
    } else {
      $scope.scheduleMessage  = 'How often would you like to send funds? Customize the loading schedule below.';
    }

    // Called on frequency selector change event
    $scope.changeFreq = function(){
      var freqOptions = recurringTransferService.setDayOptions($scope.datePicker.frequency.key);
      $scope.dayOptions = freqOptions.dayOptions;
      $scope.datePicker.day1 = freqOptions.day1;
      $scope.datePicker.day2 = freqOptions.day2;

      var dateOptions = recurringTransferService.setDateOptions($scope.datePicker);
      $scope.dateOptions = dateOptions;
      $scope.datePicker.dateSelect = dateOptions[0];

      $scope.scheduleText = recurringTransferService.updateText($scope.datePicker);
    };

    // Called on day1 selector change event
    $scope.changeDay1 = function(){
      var dateOptions = recurringTransferService.setDateOptions($scope.datePicker);
      $scope.dateOptions = dateOptions;
      $scope.datePicker.dateSelect = dateOptions[0];

      $scope.scheduleText = recurringTransferService.updateText($scope.datePicker);
    };

    // Called on day2 selector change event
    $scope.changeDay2 = function(){
      var dateOptions = recurringTransferService.setDateOptions($scope.datePicker);
      $scope.dateOptions = dateOptions;
      $scope.datePicker.dateSelect = dateOptions[0];

      $scope.scheduleText = recurringTransferService.updateText($scope.datePicker);
    };

    // Called on date selector change event
    $scope.changeDate = function(){
      $scope.scheduleText = recurringTransferService.updateText($scope.datePicker);
    };

    $scope.attemptSubmission = function (formData){
      if(!formData.$valid){
        $scope.alert.errorShown = true;
        $scope.attempted = true;
      } else {
        if(transferType == 'withdraw' && $scope.formData.Amount > $rootScope.balance){
          $scope.lowFunds = true;
        } else {
          $scope.lowFunds = false;
          $scope.alert.errorShown = false;
          if(recurringId){
            $state.go('member.home.bank/recurring/edit.step2', {transferType: transferType, recurringId: recurringId});
          } else {
            $state.go('member.home.bank/transfer/recurring.step2', {transferType: transferType});
          }
        }
      }
    };

    $scope.processForm = function (formData){
      $scope.loading = true;
      transferFunds(formData);
    };

    var transferFunds = function(formData){
      formData.FrequencyType = $scope.datePicker.frequency.key;
      formData.FrequencyDay1 = $scope.datePicker.day1.key;
      formData.StartDate     = $scope.datePicker.dateSelect.formattedDate || transfer.TransferStartDate;
      formData.BankAccountId = formData.Source.Id;
      formData.TransferType  = (transferType == 'load' ? 'in' : 'out');

      if($scope.datePicker.day2 && $scope.datePicker.day2.key){
        formData.FrequencyDay2 = $scope.datePicker.day2.key;
      } else {
        formData.FrequencyDay2 = transfer.RepeatDay2;
      }

      $http({
        method: (editUrl ? 'PUT' : 'POST'),
        url: (editUrl ? editUrl : createUrl),
        headers: {
          'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8'
        },
        data: Transform.encode(formData)
      }).then(function(resp){
        var data = resp.data;

        $scope.loading = false;
        if(data.Success){
          cacheService.clear('auto');
          if(recurringId){
            $state.go('member.home.bank/recurring/edit.confirmation', {transferType: transferType, recurringId: recurringId});
            $scope.alert.successMessage = 'You updated a recurring bank transfer';
            $scope.alert.successShown = true;
          } else {
            $state.go('member.home.bank/transfer/recurring.confirmation', {transferType: transferType});
            $scope.alert.successMessage = 'You have set a recurring bank transfer';
            $scope.alert.successShown = true;
          }
        } else {
          //$scope.transferError = true;
          $scope.alert.alertShown = true;
        }
      }).catch(function (error){
        $scope.loading = false;
        $scope.alert.alertShown = true;
      });
    };

    // remove recurring bank transfers
    $scope.removeTransfer = function(){
      $http.delete(baseURI + 'bank/transfer/auto/' + recurringId).then(function (data){
        cacheService.clear('auto');
        $state.go('member.home.transfers/manage.list', {transferType: transferType});
      });
    };

    // GET recurring transfer details, set datepicker accordingly
    var getAutoSettings = function(){
      editUrl = baseURI + 'bank/transfer/auto/' + recurringId;
      $http.get(editUrl).then(function (resp){
        transfer = resp.data.Data;
        var freqKey = transfer.Frequency;
        var freqLabel, startDate;

        $scope.formData.Amount = transfer.TransferAmount;

        // Set bank and source
        for(var a = 0; a < $scope.sources.length; a++){
          if($scope.sources[a].Id == transfer.BankSerialNo){
            $scope.formData.Source = $scope.sources[a];
            break;
          }
        }

        switch (freqKey){
          case 'M':
            freqKey = 'O';
            break;
          case 'W':
            freqKey = 'E';
            break;
        }

        // Get the correct label for frequency
        switch(freqKey){
          case 'E':
            freqLabel = 'Every Week';
            break;
          case 'F':
            freqLabel = 'Every 2 Weeks';
            break;
          case 'O':
            freqLabel = 'Once a Month';
            break;
          case 'T':
            freqLabel = 'Twice a Month';
            break;
        }

        // Initialize the frequency object
        $scope.datePicker.frequency = {
          key: freqKey,
          label: freqLabel
        };

        // Get the dayoptions for the frequency
        var freqOptions = recurringTransferService.setDayOptions(freqKey);
        $scope.dayOptions = freqOptions.dayOptions;

        if(freqKey == 'T' || freqKey == 'O'){
          $scope.datePicker.day1 = freqOptions.dayOptions[(transfer.RepeatDay1 - 1)];
          $scope.datePicker.day2 = freqOptions.dayOptions[(transfer.RepeatDay2 - 1)];
        } else {
          $scope.datePicker.day1 = freqOptions.dayOptions[transfer.RepeatDay1];
          $scope.datePicker.day2 = freqOptions.dayOptions[transfer.RepeatDay2];
        }


        // Get the dateOptions for these days
        var dateOptions = recurringTransferService.setDateOptions($scope.datePicker);
        $scope.dateOptions = dateOptions;

        // Set the formattedDate value to find the correct object in dateoptions
        $scope.datePicker.dateSelect = '';


        // format startdate to correct date object
        startDate = transfer.TransferStartDate + ' 12:30:00';

        for(var i = 0; i < dateOptions.length; i++){
          if(dateOptions[i].formattedDate == startDate){
            $scope.datePicker.dateSelect = dateOptions[i];
            break;
          }
        }

        // If dateselected is empty create and set the dateoption object
        if($scope.datePicker.dateSelect === ''){
          $scope.datePicker.dateSelect = startDate;
          var option = {
            key: moment(startDate).format('l'),
            label: moment(startDate).format('dddd, MMMM DD YYYY'),
            formattedDate: startDate
          };
          $scope.dateOptions.unshift(option);
          $scope.datePicker.dateSelect = option;
        }


        // Update the scheule text
        $scope.scheduleText = recurringTransferService.updateText($scope.datePicker);
      });
    };

    // Get user's linked bank accounts
    var getBanks = function (){
      $http.get(baseURI + 'bank?Username=' + encodeURIComponent($stateParams.username), {cache: true}).then(function (resp){
        if(resp.data.Data === null){
          $state.go('member.home.bank/add.step1');
        } else {
          $scope.sources = resp.data.Data;
        }
      }).then(function(){
        if(recurringId){
          // If we have the recurringID lets prepopulate datepicker
          getAutoSettings();
        }
      });
    };

    getBanks();

  }]);
